import { HttpContextToken } from '@angular/common/http';

export const HANDLED_ERRORS = new HttpContextToken<number[]>(() => []);
export const SKIP_AUTH_REDIRECT = new HttpContextToken<boolean>(() => false);
